import React, { createRef, useEffect, useRef, useState } from "react";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import edit from "../../images/icons/edit.png";
import delete_icon from "../../images/icons/delete.png";
import view from "../../images/icons/view.png";
import apiUtil from "../../api/apiUtil";
import Table from "../../components/Table/Table";
import { Box } from "@material-ui/core";
import getToken from "../getToken";
import api from "../../api/api";
import "./reserve.css";
import close from "../../images/icons/close.png";
import { Form, Formik } from "formik";
import CustomInput from "../../components/CustomInput/CustomInput";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import DateRangePicker from "../../components/DateRangePicker/DateRangePicker";
import * as Yup from "yup";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import SelectFilter from "../../components/SelectFilter/SelectFilter";
import DateFilter from "../../components/DateFilter/DateFilter";
import deleted_success from "../../images/icons/deleted_success.png";
import { format } from "date-fns";
import { da } from "date-fns/locale";
import { render } from "@testing-library/react";

const Reserve = () => {
  const refReserveTable = createRef();
  const [keyword, setKeyword] = useState("");
  const [showDetail, setShowDetail] = useState(false);
  const [showEditReserve, setShowEditReserve] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [filterDate, setFilterDate] = useState(null);
  const reservationId = useRef(0);

  const options = [
    { value: "", label: "All" },
    { value: "rejected", label: "Rejected" },
    { value: "pending", label: "Pending" },
    { value: "cancelled", label: "Cancelled" },
    { value: "accepted", label: "Accepted" },
  ];

  const [reserveList, setReserveList] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [paramReserve, setParamReserve] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    filterDate: null,
  });

  const retrieveReserveList = async (value = paramReserve) => {
    value.keyword = keyword || "";
    value.sortBy = selectedOption ? selectedOption.value : "";
    value.filterDate = filterDate;
    setReserveList({
      ...reserveList,
      isLoading: true,
    });
    console.log(value);

    api
      .post("Admin/GetReserveListByAdmin", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setReserveList({
                isLoading: false,
                limit: response.data.data.rowLimit,
                data:
                  response.data.data.data && response.data.data.data.length > 0
                    ? response.data.data.data
                    : [],
                total: response.data.data.totalRecords,
                page: response.data.data.paging,
              });
              console.log(reserveList.data);
            } else {
              setReserveList({
                isLoading: false,
                grouping: false,
                limit: 0,
                data: [],
                total: 0,
                page: 0,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const status_list = [
    //{ label: "Cancelled", value: 0 },
    { label: "Pending", value: 1 },
    { label: "Accepted", value: 2 },
    { label: "Rejected", value: 3 },
  ];

  const [reserveDetail, setReserveDetail] = useState({
    name: "",
    phone: "",
    email: "",
    roomName: "",
    adult: 0,
    child: 0,
    infants: 0,
    description: "",
    startDate: new Date(),
    endDate: new Date(),
    extraBed: true,
    extraBedPrice: 0,
    roomPrice: 0,
    totalPrice: 0,
    status: 1,
  });

  const clickBtnEditReserve = (e, id, mode) => {
    e.stopPropagation();
    setIsDeleted(false);
    getReserveDetails(id, mode);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  const getReserveDetails = (id, mode) => {
    api
      .get("Admin/GetReserveDetailByAdmin", { ReserveId: id }, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            const data = response.data.data;

            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setReserveDetail({
                name: data.name ?? data.name,
                email: data.email ?? data.email,
                phone: data.phone ?? data.phone,
                roomName: data.roomName ?? data.roomName,
                startDate: data.startDate ? new Date(data.startDate) : new Date(),
                endDate: data.endDate ? new Date(data.endDate) : new Date(),
                adult: data.adult ? data.adult : "0",
                child: data.child ? data.child : "0",
                infants: data.infants ? data.infants : "0",
                status: data.status !== undefined ? data.status : "",
                extraBed: data.extraBed == true ? "Yes" : "No",
                extraBedPrice: data.extraBedPrice ? data.extraBedPrice : "0",
                roomPrice: data.roomPrice ? data.roomPrice : "0",
                totalPrice: data.totalPrice ? data.totalPrice : "0",
                description: data.description ? data.description : "",
                reason: data.reason,
              });
              setShowView(mode === "view");
              setShowEditReserve(mode !== "view");

              reservationId.current = id;
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const clickBtnCloseReserve = () => {
    setShowEditReserve(false);
    setShowView(false)
  };

  const clickBtnCloseDetail = () => {
    setShowDetail(false);
    setShowView(false);
  };

  const EditReserveValidation = Yup.object().shape({
    // name: Yup.string(),
    // phone: Yup.string()
    //   .required("Please enter the phone number.")
    //   .test(
    //     "phone",
    //     "Please enter a valid phone number format. For example, 09xxxxxxxxx (or) 018xxxxxx.",
    //     (val) => /^\d{2,3}\d{7,9}$/g.test(val)
    //   ),
    // reservationDate: Yup.date().required("Please enter the reservation date."),
    // reservationTime: Yup.string().required(
    //   "Please enter the reservation time."
    // ),
    // guest: Yup.number().required("Please enter the number of guests."),
    status: Yup.string().required("Please enter the status."),
    reason: Yup.string().when('status', {
      is: '3',
      then: Yup.string().nullable().required("Please enter the reason."),
      otherwise: Yup.string().nullable()
    })
  });

  const onSubmitEditReserveHandler = (values, actions) => {
    const reservation = {
      reserveId: reservationId.current,
      name: values.name,
      email: values.email,
      phone: values.phone,
      roomName: values.roomName,
      startDate: format(new Date(values.date[0].startDate), "yyyy-MM-dd"),
      endDate: format(new Date(values.date[0].endDate), "yyyy-MM-dd"),
      adult: values.adult,
      child: values.child,
      infants: values.infants,
      extraBed: values.extraBed == "Yes" ? true : false,
      extraBedPrice: values.extraBedPrice,
      roomPrice: values.roomPrice,
      totalPrice: values.totalPrice,
      description: values.description ? values.description : "",
      status: values.status,
      reason: values.reason
    };
    console.log(reservation);

    api
      .post("Admin/UpdateReservationByAdmin", reservation, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            console.log(response);
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              alert("Reservation updated successfully!!");
              setShowEditReserve(false);
              retrieveReserveList(paramReserve);
            } else {
              alert(response.data.message);
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });

    actions.setSubmitting(false);
  };

  const [isDeleted, setIsDeleted] = useState(false);
  const clickBtnDeleteReserve = (e, id) => {
    e.preventDefault();
    setShowEditReserve(false);
    const confirmed = window.confirm(
      "Are you sure you want to delete this reservation?"
    );

    if (confirmed) {
      api
        .post(`Admin/DeleteReservationByAdmin?reserveId=${id}`, {}, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              console.log(response);
              if (response.data.code === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.value.code === 200) {
                setIsDeleted(true);
                retrieveReserveList();
              } else {
                alert(response.data.value.message);
              }
            },
            (error, type) => {
              console.log(error);
            }
          );
        });
    }
  };

  useEffect(() => {
    retrieveReserveList();

    // remove delete message after 1 min
    if (isDeleted) {
      const timeout = setTimeout(() => {
        setIsDeleted(false);
      }, 10000);

      return () => clearTimeout(timeout);
    }
  }, [paramReserve, isDeleted, selectedOption, filterDate]);

  console.log(reserveDetail);
  console.log(reserveList);

  return (
    <>
      {showView && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">Reservation Detail </h6>
            <button className="btn btnClose" onClick={clickBtnCloseReserve}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>
          <Formik
            initialValues={{
              name: reserveDetail.name ?? reserveDetail.name,
              email: reserveDetail.email ?? reserveDetail.email,
              phone: reserveDetail.phone ?? reserveDetail.phone,
              roomName: reserveDetail.roomName ?? reserveDetail.roomName,
              adult: reserveDetail.adult ? reserveDetail.adult : "0",
              child: reserveDetail.child ? reserveDetail.child : "0",
              infants: reserveDetail.infants ? reserveDetail.infants : "0",
              status: reserveDetail.status !== undefined ? reserveDetail.status : "",
              description: reserveDetail.description ? reserveDetail.description : "",
              extraBed: reserveDetail.extraBed == true ? "Yes" : "No",
              extraBedPrice: reserveDetail.extraBedPrice ? reserveDetail.extraBedPrice : "0",
              roomPrice: reserveDetail.roomPrice ? reserveDetail.roomPrice : "0",
              totalPrice: reserveDetail.totalPrice ? reserveDetail.totalPrice : "0",
              reason: reserveDetail.reason,
              date:
                reserveDetail.startDate || reserveDetail.endDate
                  ? [
                    {
                      startDate: new Date(reserveDetail.startDate),
                      endDate: new Date(reserveDetail.endDate),
                      key: "selection",
                    },
                  ]
                  : "",
            }}
            validationSchema={EditReserveValidation}
            validateOnBlur={false}
            onSubmit={(values, actions) => {
              onSubmitEditReserveHandler(values, actions);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className="row form-container edit-reserve-form">
                <h6 className="title_text mt-0">Reservation Information</h6>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="name"
                    type="text"
                    label="Name"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="email"
                    type="text"
                    label="Email"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="phone"
                    type="text"
                    label="Phone Number"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <DateRangePicker
                    name="date"
                    label="Date"
                    customclass="input_wrapper"
                    disabled={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="roomName"
                    type="text"
                    label="Room Name"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="adult"
                    type="number"
                    label="Adult"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="child"
                    type="number"
                    label="Child"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />

                </div>
                {/*
                <div className="col-6 mt-2">
                  <CustomInput
                    name="infants"
                    type="number"
                    label="Infants"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
              */}
                <div className="col-6 mt-2">
                  <CustomInput
                    name="extraBed"
                    type="text"
                    label="Extra Bed"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="extraBedPrice"
                    type="text"
                    label="Extra Bed Price"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="roomPrice"
                    type="text"
                    label="Room Price"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="totalPrice"
                    type="text"
                    label="Total Price"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="description"
                    type="text"
                    label="Special Request"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomSelect
                    options={values.status === 0 ? [{ label: "Cancelled", value: 0 }] : status_list}
                    name="status"
                    label="Status"
                    isClearable={false}
                    placeholder="Select status"
                    disabled={true}
                  />
                </div>
                {values.status === 3 &&
                  (
                    <div className="col-12 mt-2">
                      <CustomInput
                        name="reason"
                        type="text"
                        label="Reason"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>
                  )}
              </Form>
            )}
          </Formik>
        </>
      )}

      {/* Edit Reserve Form */}
      {showEditReserve && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">Edit Reserve List</h6>
            <button className="btn btnClose" onClick={clickBtnCloseReserve}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>
          <Formik
            initialValues={{
              name: reserveDetail.name ?? reserveDetail.name,
              email: reserveDetail.email ?? reserveDetail.email,
              phone: reserveDetail.phone ?? reserveDetail.phone,
              roomName: reserveDetail.roomName ?? reserveDetail.roomName,
              adult: reserveDetail.adult ? reserveDetail.adult : "0",
              child: reserveDetail.child ? reserveDetail.child : "0",
              infants: reserveDetail.infants ? reserveDetail.infants : "0",
              status: reserveDetail.status !== undefined ? reserveDetail.status : "",
              description: reserveDetail.description !== undefined ? reserveDetail.description : "",
              extraBed: reserveDetail.extraBed ? reserveDetail.extraBed : "0",
              extraBedPrice: reserveDetail.extraBedPrice ? reserveDetail.extraBedPrice : "0",
              roomPrice: reserveDetail.roomPrice ? reserveDetail.roomPrice : "0",
              totalPrice: reserveDetail.totalPrice ? reserveDetail.totalPrice : "0",
              reason: reserveDetail.reason,
              date:
                reserveDetail.startDate || reserveDetail.endDate
                  ? [
                    {
                      startDate: new Date(reserveDetail.startDate),
                      endDate: new Date(reserveDetail.endDate),
                      key: "selection",
                    },
                  ]
                  : "",
            }} enableReinitialize={true}
            validationSchema={EditReserveValidation}
            onSubmit={(values, actions) => {
              onSubmitEditReserveHandler(values, actions);
            }}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form className="row form-container edit-reserve-form">
                <h6 className="title_text mt-0">Reservation Information</h6>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="name"
                    type="text"
                    label="Name"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="email"
                    type="text"
                    label="Email"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="phone"
                    type="text"
                    label="Phone Number"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <DateRangePicker
                    name="date"
                    label="Date"
                    customclass="input_wrapper"
                    disabled={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="roomName"
                    type="text"
                    label="Room Name"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="adult"
                    type="number"
                    label="Adult"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="child"
                    type="number"
                    label="Child"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                {/* <div className="col-6 mt-2">
                  <CustomInput
                    name="infants"
                    type="number"
                    label="Infants"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div> */}
                <div className="col-6 mt-2">
                  <CustomInput
                    name="extraBed"
                    type="text"
                    label="Extra Bed"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="extraBedPrice"
                    type="text"
                    label="Extra Bed Price"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="roomPrice"
                    type="text"
                    label="Room Price"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="totalPrice"
                    type="text"
                    label="Total Price"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="description"
                    type="text"
                    label="Special Request"
                    customclass="input_wrapper"
                    hideicon="true"
                    readOnly={true}
                  />
                </div>
                <div className="col-12 mt-2">
                  <CustomSelect
                    options={values.status === 0 ? [{ label: "Cancelled", value: 0 }] : status_list}
                    name="status"
                    label="Status"
                    isClearable={false}
                    placeholder="Select status"
                    value={status_list.find(
                      (option) => option.value === values.status
                    )}
                    onChange={(selectedOption) =>
                      setFieldValue("status", selectedOption.value)
                    }
                    disabled={values.status === 2 || values.status === 3}
                  />
                </div>
                {values.status === 3 &&
                  (
                    <div className="col-12 mt-2">
                      <CustomInput
                        name="reason"
                        type="text"
                        label="Reason"
                        customclass="input_wrapper"
                        hideicon="true"
                      />
                    </div>
                  )
                }
                <div className="col-12 mt-3">
                  <div className="Actions justify-content-end">
                    <button
                      type="button"
                      className="button btnCancel"
                      onClick={clickBtnCloseReserve}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="button btnUpdate">
                      Update
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </>
      )}

      {isDeleted && (
        <div className="Actions justify-content-center  deleted-alert">
          <img src={deleted_success} alt="delete" />
          <p className="mb-0">The reservation has been successfully deleted!</p>
        </div>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Reserve List</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <DateFilter filterDate={filterDate} setFilterDate={setFilterDate} />
          <SelectFilter
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            options={options}
            defaultValue="Status"
          />
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveReserveList()}
          />

        </div>
      </div>

      <div className="table_container reserve_table">
        <Table
          key={reserveList.total}
          ref={refReserveTable}
          maxBodyHeight={reserveList.limit * 80}
          isLoading={reserveList.isLoading}
          grouping={reserveList.grouping}
          limit={reserveList.limit}
          page={reserveList.page}
          total={reserveList.total}
          data={reserveList.data}
          onPageChange={(page) => {
            setParamReserve({
              ...paramReserve,
              currentPage: page,
            });
            retrieveReserveList(paramReserve);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex = (reserveList.page - 1) * reserveList.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },
            {
              title: "Name",
              render: (row) => {
                return row.name ? row.name : "";
              },
              width: "180px",
            },
            {
              title: "Phone",
              render: (row) => {
                return row.phone ? row.phone : "";
              },
              width: "160px",
            },
            {
              title: "Room Name",
              field: "roomName",
              width: "160px",
            },
            {
              title: "Start Date",
              render: (row) => {
                return apiUtil.getDateShortMonthFormat(row.startDate);
              },
              width: "150px",
            },
            {
              title: "End Date",
              render: (row) => {
                return apiUtil.getDateShortMonthFormat(row.endDate);
              },
              width: "150px",
            },
            {
              title: "Status",
              render: (row) => {
                const getStatus = () => {
                  switch (row.status) {
                    case 0:
                      return {
                        statusName: "Cancelled",
                        statusClassName: "status-rejected",
                      };
                    case 1:
                      return {
                        statusName: "Pending",
                        statusClassName: "status-pending",
                      };
                    case 2:
                      return {
                        // statusName: "Approved",
                        statusName: "Accepted",
                        statusClassName: "status-approved",
                      };
                    case 3:
                      return {
                        statusName: "Rejected",
                        statusClassName: "status-rejected",
                      };
                    default:
                      return {};
                  }
                };
                return (
                  <div
                    className={` status-container ${getStatus().statusClassName
                      } `}
                  >
                    <div className="status-dot"></div>
                    {getStatus().statusName}
                  </div>
                );
              },
              width: "120px",
            },
            // {
            //   title: "Delete",
            //   sorting: false,
            //   render: (row) => {
            //     return (
            //       <Box
            //         className=" cursor-pointer"
            //         onClick={(e) => clickBtnDeleteReserve(e, row.id)}
            //       >
            //         <img src={delete_icon} alt="" className="imgIcon" />
            //       </Box>
            //     );
            //   },
            //   width: "80px",
            //   align: "center",
            // },
            {
              title: "Edit",
              sorting: false,
              render: (row) => {
                return (
                  <Box
                    className=" cursor-pointer"
                    onClick={(e) =>
                      clickBtnEditReserve(e, row.id, setShowEditReserve)
                    }
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              width: "80px",
              align: "center",
            },
            {
              title: "View",
              sorting: false,
              render: (row) => {
                return (
                  <Box
                    className="cursor-pointer"
                    onClick={(e) =>
                      clickBtnEditReserve(e, row.id, "view")
                    }
                  >
                    <img src={view} alt="" className="imgViewIcon" />
                  </Box>
                );
              },
              width: "80px",
              align: "center",
            },
          ]}
        />
      </div>
    </>
  );
};

export default Reserve;
